import { useEffect, useState } from "react";
import { purchasesHistoryRequest } from "./PurchasesHistoryRequest";
import "../../../../css/wallet/History/PurchasesHistory.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import HistoryLoading2 from "../HistoryLoading2";

function PurchasesHistory({ theme }) {
  const [requestStatus, setRequestStatus] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    purchasesHistoryRequest(setRequestStatus, setData);
  }, []);

  const { t } = useTranslation();

  const navigate = useNavigate();

  return data.length > 0 ? (
    <>
      {requestStatus ? (
        <HistoryLoading2 theme={theme}></HistoryLoading2>
      ) : (
        <div className="productsDiv padding12">
          {data.length === 0 ? (
            <div>{t("No products found.")}</div>
          ) : (
            data.map((product, index) => {
              const images = product.images || [];

              return (
                <div
                  className="productPreviewDiv"
                  key={index}
                  onClick={() => {
                    navigate("/transaction/" + product.link);
                  }}
                >
                  <div className="productPreviewUserDiv">
                    {product.user[0].profile_image_url !== null ? (
                      <img src={product.user[0].profile_image_url}></img>
                    ) : (
                      <div className="profileImageDivInProductDiv"></div>
                    )}

                    <div>{product.user[0].username}</div>

                    {product.user[0].tick && (
                      <div className="tickDivInProductDiv">
                        <img src="/icons/green_tick.png"></img>
                      </div>
                    )}
                  </div>

                  <div className="productDataDiv">
                    <div className="productImageSlider">
                      {images.length > 0 ? (
                        images.map((image, index) => (
                          <img
                            key={index}
                            src={image}
                            alt={`${product.name} ${index + 1}`}
                            className="productImage"
                            loading="lazy"
                            decoding="async"
                          />
                        ))
                      ) : (
                        <div className="productNoImage">{t("No Image")}</div>
                      )}
                    </div>
                    <div className="productInfoDivInProductPreview">
                      <div>
                        {product.name?.length > 20
                          ? product.name.slice(0, 20) + "..."
                          : product.name}
                      </div>

                      <div className="productPrice">
                        {Number(product.price).toLocaleString()} t
                      </div>

                      <div className="">{product.quantity}</div>
                      <div className="">{product.status}</div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      )}
    </>
  ) : (
    <div className="emptyDiv">
      <img src="/images/empty512.png"></img>
      <div className="emptyTitleDiv">{t("Empty")}</div>
    </div>
  );
}

export default PurchasesHistory;
